/* global Intercom */
/* eslint-disable new-cap */

let submitInterval = 2000;

function retry(callback) {
  submitInterval *= 2;
  // eslint-disable-next-line no-use-before-define
  setTimeout(() => sendToProvider(callback), submitInterval);
}

function sendToProvider(callback) {
  try {
    callback();
  } catch (e) {
    retry(callback);
  }
}

export default {
  trackEvent: (event, metadata) => {
    sendToProvider(() => Intercom('trackEvent', event, metadata));
  }
};



// WEBPACK FOOTER //
// ./webpack/components/Modules/Analytics/Analytics.js